/* eslint-disable */
import { EventEmitter } from 'events';
import moment from 'moment';
import { ICrontabRecord, RepoCrontabStatus } from '../../../model';
import { LoopFrequency } from '../../loop-frequency';
import { Crontab } from './crontab';

// 定时轮询频率，默认60s执行一次
const FREQUENCY_TIMER = 60000;

/**
 * @class CrontabPool
 * @description 定时任务池，负责频率控制，计算各个任务是否执行
 */
export class CrontabPool extends EventEmitter {
  private loopFrequency: null | LoopFrequency = null;
  private frequencyTimer: number = FREQUENCY_TIMER;
  private crontabQueue = new Map<string, Crontab<any> | null>();

  public constructor() {
    super();
    this.init();
  }

  public stop() {
    if (this.loopFrequency) {
      this.loopFrequency.stop();
      this.loopFrequency = null;
    }
  }

  public add<T>(crontabID: string, crontabInstance: Crontab<T>) {
    const crontab = this.query<T>(crontabID);
    if (crontab) {
      this.crontabQueue.delete(crontabID);
    }

    this.crontabQueue.set(crontabID, crontabInstance);
    console.log('crontab-pool-add', crontabID);
  }

  public remove(crontabID: string) {
    this.crontabQueue.forEach((crontab) => {
      if (!crontab) {
        return;
      }
      if (
        crontab.crontabID.includes(crontabID) ||
        crontab.crontabID === crontabID
      ) {
        this.crontabQueue.set(crontab.crontabID, null);
      }
    });
  }

  public query<T>(crontabID: string) {
    const data = this.crontabQueue.get(crontabID);
    if (data) {
      return data as Crontab<T>;
    }
    return null;
  }

  private init() {
    this.loop();
  }

  private loop() {
    this.loopFrequency = new LoopFrequency(
      this.frequencyTimer,
      (_loopFrequencyInstance) => {
        this.crontabTimerComparison();
      }
    );
  }

  /**
   * @function timerComparison
   * @description 每一项对比，跳过*号，如果不一致则不命中
   * @param crontabSetTime [年, 月, 日, 时, 分, 秒]
   * @param currentTime [年, 月, 日, 时, 分, 秒]
   */
  private timerComparison(
    crontabSetTimes: ReadonlyArray<ReadonlyArray<string>>,
    currentTime: ReadonlyArray<string>
  ): boolean {
    let noHitCount = 0;

    for (let k = 0; k < crontabSetTimes.length; k++) {
      const crontabSetTime = crontabSetTimes[k];
      for (let i = 0; i < crontabSetTime.length; i++) {
        const element = crontabSetTime[i];
        if (element === '*') {
          continue;
        }
        if (currentTime[i] !== element) {
          noHitCount = noHitCount + 1;
          break;
        }
      }
    }

    return noHitCount !== crontabSetTimes.length;
  }

  private crontabTimerComparison() {
    const crontab = this.crontabQueue;
    const currentTime = moment().format('YYYY MM DD HH mm ss').split(/\s+/g);
    crontab.forEach(async (crontab) => {
      if (!crontab) {
        return;
      }
      if (crontab.status !== RepoCrontabStatus.Running) {
        return;
      }

      const isHit = this.timerComparison(crontab.time, currentTime);
      if (isHit) {
        console.log('crontab-pool-hit-60s', crontab.crontabID, currentTime);
        if (crontab.taskInstance) {
          crontab.taskInstance.updateLocalTask?.(crontab.crontabID);
          const result: ICrontabRecord = await crontab.taskInstance.trigger(
            crontab
          );
          crontab.taskInstance.updateLocalTask?.(crontab.crontabID, result);
        }
        this.emit('TaskTrigger', crontab);
      }
    });
  }

  public testRun() {
    const cronjobs = this.crontabQueue;
    cronjobs.forEach(async (crontab) => {
      if (!crontab) {
        return;
      }
      if (crontab.status !== RepoCrontabStatus.Running) {
        return;
      }
      const result = await crontab.taskInstance.trigger(crontab);
      crontab.taskInstance.updateLocalTask?.(crontab.crontabID, result);
      this.emit('TaskTrigger', crontab);
    });
  }
}
